import { render } from "./Lppd.vue?vue&type=template&id=e85cfba4"
import script from "./Lppd.vue?vue&type=script&lang=js"
export * from "./Lppd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__